import * as React from 'react';
import {Box, Typography, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import StockedTakingReports from "./StockedTakingReports";
import InventoryReports from "./InventoryReports";

type Props = {
	storage: StorageType;
};

const Overview: React.FC<Props> = ({ storage }) => {
	const theme = useTheme();

	return (
		<Grid container spacing={2} size={{ xs: 12 }}>
			<Grid size={{ xs: 12 }}>
				<Box
					sx={{
						backgroundColor: theme.palette.headerBackground,
						p: 2,
						height: 50,
						borderBottom: theme.palette.border,
					}}>
					<Typography variant="h5" sx={{ ...theme.typography.usersFontTitle }}>
						{storage.name}
					</Typography>
				</Box>

			</Grid>
			<Grid size={{ xs: 12 }}>
				<StockedTakingReports storage={storage} />
				<InventoryReports storage={storage} />
			</Grid>
		</Grid>
	);
};

export default Overview;
